import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["loading", "size", "children"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { system } from '@xstyled/styled-components';
import { LoadingSpinner } from '../loading';
import { forwardRef } from 'react';
import { styleVariables } from '../../style';
import { Button } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextLinkButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  font-size: ", ";\n  color: ", ";\n  padding: 0px;\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), system, function (props) {
  return props.size === 'large' ? '16px' : '14px';
}, styleVariables.colors.colorPrimaryBase, styleVariables.colors.blue3);
export var TextLinkButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var loading = props.loading,
      _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(StyledTextLinkButton, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    size: size,
    type: "link",
    loading: false,
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      primary: true
    }) : children
  }));
});
TextLinkButton.displayName = 'TextLinkButton';